/* This example requires Tailwind CSS v2.0+ */

import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";

import { SearchIcon } from "@heroicons/react/solid";

interface Props {
  rowCount: number;
  pageSize: number;
  selectedPage: number;
  total: number;
  location: string;
  handleBlurSearch: (search: string) => void;
  handleChangePage: (page: number) => void;
  handleKeyUp: (e: any) => void;
}

export default function Pagination({
  rowCount,
  pageSize,
  selectedPage,
  total,
  location = "header",
  handleBlurSearch,
  handleChangePage,
  handleKeyUp
}: Props) {
  
  const numberOfPages = Math.ceil(total / pageSize);

  return (
    <div className="bg-gray-50 px-4 py-3 flex items-center justify-between sm:px-6">
      <div className="flex-1 flex justify-between sm:hidden">
        <a
          href="/"
          className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Previous
        </a>
        <a
          href="/"
          className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Next
        </a>
      </div>
      <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div className="flex">
          <label htmlFor="search-field" className="sr-only">
            Search
          </label>
          <div className="relative w-full text-gray-400 focus-within:text-gray-600">
            <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none pl-2">
              <SearchIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
            <input
              id="search-field"
              className="block w-full h-full pl-10 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-300 focus:outline-none focus:placeholder-gray-300 focus:ring-1 sm:text-sm border border-gray-300 rounded-md"
              placeholder="Search by Name"
              onBlur={(e) => handleBlurSearch(e.target.value)}
              onKeyUp={(e) => handleKeyUp(e)}
              type="search"
              name="search"
            />
          </div>
        </div>
        <div>
          <p className="text-sm text-gray-700">
            Showing{" "}
            {total > 0 && (
              <>
                <span className="font-medium">
                  {(selectedPage - 1) * pageSize + 1}
                </span>{" "}
                to{" "}
                <span className="font-medium">
                  {total < selectedPage * pageSize
                    ? total
                    : selectedPage * pageSize}
                </span>{" "}
                of{" "}
              </>
            )}
            <span className="font-medium">{total}</span> results
          </p>
        </div>
        <div>
          <nav
            className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
            aria-label="Pagination"
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                handleChangePage(selectedPage - 1);
              }}
              disabled={selectedPage === 1}
              className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            {new Array(numberOfPages).fill(0).map((_, index) => {
              const isCurrent = index + 1 === selectedPage;

              if (numberOfPages >= 7 && index === 3) {
                return (
                  <button
                    key={"page-" + index}
                    aria-current="page"
                    disabled={true}
                    className={
                      isCurrent
                        ? "z-10 relative inline-flex items-center px-4 py-2 border text-sm font-medium bg-blue-50 border-blue-500 text-blue-600 "
                        : "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    }
                  >
                    {"..."}
                  </button>
                );
              } else if (
                numberOfPages >= 7 &&
                index > 3 &&
                index < numberOfPages - 3
              ) {
                return null;
              } else {
                return (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleChangePage(index + 1);
                    }}
                    key={"page-" + index}
                    aria-current="page"
                    disabled={isCurrent}
                    className={
                      isCurrent
                        ? "z-10 relative inline-flex items-center px-4 py-2 border text-sm font-medium bg-blue-50 border-blue-500 text-blue-600 "
                        : "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    }
                  >
                    {index + 1}
                  </button>
                );
              }
            })}

            <button
              onClick={(e) => {
                e.preventDefault();
                handleChangePage(selectedPage + 1);
              }}
              disabled={selectedPage === numberOfPages}
              className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}
